module.exports = __webpack_public_path__ + "img/0b7a254.png";